import * as React from 'react';
import { useSelector } from 'react-redux';

import { IPhoneSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { CallButton } from '../../../components/NewbuildingDecorations/parts/NewbuildingDecorationsBanner/parts/CallButton/CallButton';
import { getDynamicCalltrackingSiteBlockId } from '../../../selectors/getDynamicCalltrackingSiteBlockId';
import { getOffer, getOfferPhones } from '../../../selectors/newObject';
import { getAgent } from '../../../selectors/newObject/getAgent';
import { getFormattedPhoneNumber } from '../../../utils/formatters';
import { getCustomUrl } from '../../../utils/tracking/getCustomUrl';
import { trackPhoneOpen } from '../tracking';

export const ABCallButtonContainer: React.FC = () => {
  const [isPhoneVisible, showPhone] = React.useState(false);

  const offer = useSelector(getOffer);
  const phones = useSelector(getOfferPhones);
  const siteBlockId = useSelector(getDynamicCalltrackingSiteBlockId);
  const agent = useSelector(getAgent);
  const filteredPhones = phones && phones.filter((phone: IPhoneSchema) => !!phone.number);
  const phone = filteredPhones && filteredPhones.map(getFormattedPhoneNumber).join(', ');
  const gaLabel = getCustomUrl(offer, agent);

  const handleShowPhoneClick = React.useCallback(() => {
    showPhone(true);
    trackPhoneOpen(gaLabel);
  }, [gaLabel]);

  if (!filteredPhones || !filteredPhones.length) {
    return null;
  }

  return (
    <CallButton
      isPhoneVisible={isPhoneVisible}
      handleShowPhoneClick={handleShowPhoneClick}
      phone={phone}
      announcementId={offer.id}
      siteBlockId={siteBlockId}
      size="XS"
      fill="fill_primary"
    />
  );
};
